import type { ReactNode } from 'react';
import { cn } from './cn.js';

/// O que a situação SIGNIFICA, não a cor que ela tem. A tela escolhe o tom pela leitura do dado
/// ("está resolvido", "está a caminho", "exige ação"), e a paleta fica em um lugar só.
export type StatusTone = 'positive' | 'progress' | 'warning' | 'danger' | 'brand' | 'neutral';

/// Pílula de situação, igual em toda tela do sistema.
///
/// Existe porque cada listagem estava pintando a própria: o mesmo "resolvido" saía em verdes
/// diferentes conforme a tela, e os tons escolhidos só enxergavam bem no tema escuro. As cores
/// vivem no CSS (`.hue-status-*`), que é onde dá para dar a cada tom o par escuro/claro.
export function StatusPill({
  tone,
  icon,
  children,
  className,
}: {
  tone: StatusTone;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={cn('hue-status', `hue-status-${tone}`, className)}>
      {icon ? <span aria-hidden="true">{icon}</span> : null}
      {children}
    </span>
  );
}
